/**
 * ROOM TINT (ROOMS.md §6b) — while a room is open, the app's neutral lines take a light tint of the room's identity
 * hue (the same hue as its avatar: ``roomVisual(networkId, poolId).hue``). Sets ``--room-hue`` + ``data-room-tint`` on
 * <html>; the CSS (apps/web/src/index.css "ROOM TINT") does the rest. Leaving the room (unmount / room switch) removes
 * both → the default lines return. One room at a time: the latest open room owns the tint.
 */
import { useEffect } from 'react';
import { roomVisual } from '../components/dashboard/RoomAvatar.jsx';

export default function useRoomTint(networkId, poolId, enabled = true) {
  useEffect(() => {
    if (!enabled || !networkId || typeof document === 'undefined') return undefined;
    const el = document.documentElement;
    const { hue } = roomVisual(networkId, poolId || 'default');
    const key = `${networkId}:${poolId || 'default'}`;
    el.style.setProperty('--room-hue', String(Math.round(hue)));
    el.setAttribute('data-room-tint', key);
    return () => {
      if (el.getAttribute('data-room-tint') === key) {   // a newer room may already own it
        el.removeAttribute('data-room-tint');
        el.style.removeProperty('--room-hue');
      }
    };
  }, [networkId, poolId, enabled]);
}
